// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"29f395be","101":"08d70710","249":"0b1df3f7","254":"305c6bac","496":"aba5ba32","551":"980a301a","885":"3057b224"}[chunkId] + ".chunk.js";
};